import React from 'react'
import { FormattedMessage } from 'react-intl'
import { connect } from 'formik'
import { Select, Option } from '@iui-kit/components/Select'
import { HOURS } from '@src/constants/AdvertisingBriefs'
import * as FIELD_NAMES from '@src/constants/AdvertisingBriefs/Search/fieldNames'
import BEM from '@iui-kit/utils/bem'

const bem = new BEM(require('./WorkTime.css'))

const WorkTime = props => {
  const {
    formik: { values, errors, setFieldValue }
  } = props

  const handleChangeCountry = (value: string, name: string) => {
    setFieldValue(name, value)
  }

  return (
    <div className={bem.b('WorkTime').show()}>
      <div
        className={bem
          .b('WorkTime')
          .e('column')
          .show()}
      >
        <label
          className={bem
            .b('WorkTime')
            .e('label')
            .m('first')
            .show()}
        >
          <FormattedMessage id="Brief.field.workTime.start.label" />
        </label>
        <Select
          className={bem
            .b('WorkTime')
            .e('select')
            .show()}
          isValid={!errors[FIELD_NAMES.CARD_WORKING_START_TIME]}
          value={values[FIELD_NAMES.CARD_WORKING_START_TIME]}
          onChange={value => handleChangeCountry(value, FIELD_NAMES.CARD_WORKING_START_TIME)}
        >
          {HOURS.map((value, idx) => (
            <Option key={value} value={`${idx + 1}`}>
              {value}
            </Option>
          ))}
        </Select>
      </div>
      <div
        className={bem
          .b('WorkTime')
          .e('column')
          .show()}
      >
        <label
          className={bem
            .b('WorkTime')
            .e('label')
            .show()}
        >
          <FormattedMessage id="Brief.field.workTime.end.label" />
        </label>

        <Select
          className={bem
            .b('WorkTime')
            .e('select')
            .show()}
          isValid={!errors[FIELD_NAMES.CARD_WORKING_END_TIME]}
          value={values[FIELD_NAMES.CARD_WORKING_END_TIME]}
          onChange={value => handleChangeCountry(value, FIELD_NAMES.CARD_WORKING_END_TIME)}
        >
          {HOURS.map((value, idx) => (
            <Option key={value} value={`${idx + 1}`}>
              {value}
            </Option>
          ))}
        </Select>
      </div>
    </div>
  )
}

export default connect(WorkTime)
